<div *ngIf="pageContent.isLoading === true" class="u-flex-pull-left">
  <i class="fas fa-spinner-third fa-fw fa-spin" aria-hidden="true"></i>
  <span i18n="@@pageContent-loadingIndicator-status-loading">
    Loading page content, please wait&hellip;
  </span>
</div>

<div
  *ngIf="pageContent.isLoading !== true && pageContent.data?.content"
  [innerHTML]="pageContent.data.content"
></div>

<div
  *ngIf="pageContent.isLoading !== true && pageContent.loadingError"
  i18n="@@pageContent-loadingIndicator-status-error"
  role="alert"
>
  There was an error loading page content
</div>
